import request from '@/utils/request'

export function fetchMchListByAgent(data) {
  return request({
    url: '/merchant-api/mch/agent/getMchListByAgent',
    method: 'post',
    data
  })
}

export function fetchSubMchAppDetail(data) {
  return request({
    url: '/merchant-api/mch/agent/subMchApp/peekInfo',
    method: 'post',
    data
  })
}

export function updateSubMchApp(data) {
  return request({
    url: '/merchant-api/mch/agent/subMchApp/update',
    method: 'post',
    data
  })
}


